import { VaultDepositor } from '@velocity-exchange/vaults-sdk';
import { Vault } from '@velocity-exchange/vaults-sdk';
import { SerializedVaultDepositorRecord } from 'src/db/schema/vault-depositor-records';

import { QUOTE_PRECISION_EXP, BigNum, BN } from '@velocity-exchange/sdk';
import { ZERO_QUOTE_BIGNUM } from 'src/constants/math';
import { VaultStats } from 'src/@types/vaults';
import {
	getVaultDepositorBalance,
	getVaultDepositorNotionalNetDeposits,
} from 'src/utils/vault/math';

export const calcVaultDepositorBasePnl = ({
	vaultDepositor,
	vault,
	vaultAssetPrecision,
	vaultStats,
}: {
	vaultDepositor: VaultDepositor;
	vault: Vault;
	vaultAssetPrecision: BN;
	vaultStats: VaultStats;
}) => {
	if (!vaultStats) return ZERO_QUOTE_BIGNUM;

	const vaultDepositorBalance = getVaultDepositorBalance(
		vaultDepositor,
		{
			totalShares: vault.totalShares,
			profitShare: vault.profitShare,
		},
		vaultStats.tvlBase,
		vaultAssetPrecision,
		true
	);

	const totalBasePnL = vaultDepositorBalance.sub(
		BigNum.from(vaultDepositor.netDeposits, vaultAssetPrecision)
	);

	return totalBasePnL;
};

export const calcVaultDepositorNotionalPnl = ({
	vaultDepositor,
	vault,
	oraclePrice,
	vaultAssetPrecision,
	vaultStats,
	vaultDepositorHistory,
}: {
	vaultDepositor: VaultDepositor;
	vault: Vault;
	oraclePrice: BigNum | undefined;
	vaultAssetPrecision: BN;
	vaultStats: VaultStats;
	vaultDepositorHistory: SerializedVaultDepositorRecord[];
}) => {
	const vaultDepositorBalance = getVaultDepositorBalance(
		vaultDepositor,
		{
			totalShares: vault.totalShares,
			profitShare: vault.profitShare,
		},
		vaultStats.tvlBase,
		vaultAssetPrecision,
		true
	);
	const userNotionalBalance = vaultDepositorBalance
		.mul(oraclePrice ?? ZERO_QUOTE_BIGNUM)
		.shiftTo(QUOTE_PRECISION_EXP);

	const userNotionalNetDeposits = getVaultDepositorNotionalNetDeposits(
		vaultDepositorHistory
	);

	const netNotionalPnl = userNotionalBalance.sub(userNotionalNetDeposits);

	return netNotionalPnl;
};
